"use client";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import Image from "next/image";
import React, { useCallback, useEffect, useMemo, useState } from "react";
// import CountDown from "./CountDown";
import { ClaimData, ResponseObject } from "@/app/classes/main";
import { ApiService } from "@/app/services/AppService";
import "./index.css";
import { getToken } from "@/app/services/HolderService";
import { getHubId } from "../../components/genericComponents/helper-functions/currencyCode.js";
import { useCurrencyCode } from "../genericComponents/helper-functions/CurrencySymbol";
import Login from "../login/Login";
import { AddToCartService } from "@/app/services/cart";
import ClaimServiceAlert from "./ClaimServiceAlert";
import Cookies from "js-cookie";
import { trackEvent } from "@/app/utils/branch";
import CountDown from "./CountDown";

interface claimServiceProps {
  claimService: ClaimData;
}

export const ClaimServices: React.FC<claimServiceProps> = ({
  claimService,
}) => {
  const currencyCode = useCurrencyCode();
  const apiService = useMemo(() => new ApiService(), []);
  const [claimData, setClaimData] = useState<ClaimData | undefined>(
    claimService
  );
  const [showRemoveCart, setShowRemoveCart] = useState<
    { id: any; inCart: boolean }[] | undefined
  >(undefined);
  const [showLoginBox, setShowLoginBox] = useState(false);
  const [showClaimMessage, setShowClaimMessage] = useState(false);
  const [updateClaimService, setUpdateClaimService] = useState(false);
  const token = getToken();
  const xHubId = getHubId();
  const addToCartService = new AddToCartService();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => trackEvent("HOME", null), []);

  useEffect(() => {
    const claimServiceAvailiableInLocal = localStorage.getItem("claimService");
    if (!claimServiceAvailiableInLocal) {
      const initialShowRemoveCart = claimData?.servicesList?.map(
        (service: any) => ({
          id: service.id,
          inCart: false,
        })
      );
      setShowRemoveCart(initialShowRemoveCart);
    } else {
      const claimServiceBool = JSON.parse(
        atob(localStorage.getItem("claimService") as string)
      );
      setShowRemoveCart(claimServiceBool);
    }
  }, [claimData]);

  const handleTimer = async (item: any, index: any) => {
    if (token) {
      try {
        const payload = {
          claimServiceId: item.cid.toString(),
          serviceId: item.id,
        };
        await apiService.post<ResponseObject>(
          apiService.claimFreeService +
            "?claimServiceId=" +
            payload.claimServiceId +
            "&serviceId=" +
            payload.serviceId,
          payload,
          getToken()!
        );
        setUpdateClaimService(true);
      } catch (error) {
        console.log("Error :", error);
      }
    } else {
      setShowLoginBox(true);
    }
  };

  const handleAddToCart = async (item: any) => {
    try {
      const payload = {
        claimId: item.cid.toString(),
        claimServiceValidateRequestItems: [
          {
            serviceId: item.id,
          },
        ],
      };
      const responseObject = await apiService.post<ResponseObject>(
        apiService.validateClaimFreeService,
        payload,
        getToken()!
      );

      if (responseObject?.object.flag === true) {
        const isAnyItemInCart = showRemoveCart?.some(
          (cartItem: any) => cartItem.inCart === true
        );
        const isCurrentItemInCart = showRemoveCart?.find(
          (cartItem: any) => cartItem.id === item.id // Check if the clicked item is already in the cart
        );

        if (isAnyItemInCart && isCurrentItemInCart?.inCart === false) {
          console.log("Remove first service");
          // alert("You Can Claim Only One Service OR You Can Change Service");
          return;
        }
        // Update the inCart state
        const updatedItems = showRemoveCart?.map((currentItem: any) =>
          currentItem.id === item.id
            ? { ...currentItem, inCart: !currentItem.inCart } // Toggle inCart state
            : currentItem
        );
        // Update the cart service
        await addToCartService.addToCart(
          item.id,
          isCurrentItemInCart ? false : true,
          item.cid,
          item?.coverImage?.secureHttpPath,
          item?.aboutList,
          item?.subHeading,
          item?.serviceCharge,
          item?.productCost,
          item?.min,
          item?.specialPrice,
          item?.specialMessage
        );
        setShowRemoveCart(updatedItems);
        localStorage.setItem(
          "claimService",
          btoa(JSON.stringify(updatedItems))
        );
      } else {
        setShowClaimMessage(true);
      }
    } catch (error) {
      console.log("Error :", error);
    }
  };

  function handleUserLoggedIn() {
    localStorage.setItem("isAlreadyLogin", "true");
    Cookies.set("isAlreadyLogin", "true", {
      expires: 365,
      secure: true,
      sameSite: "Strict", // or 'Lax', depending on your use case
    });
    // setAlreadyLogin(true);
    window.location.reload();
  }

  const getClaimServices = useCallback(async () => {
    if (token) {
      try {
        const responseObject: ResponseObject | undefined =
          await apiService.get<ResponseObject>(
            apiService.claimServicesWithLogin,
            token,
            xHubId
          );
        setClaimData(responseObject?.object);
      } catch (error) {
        console.log("Error:", error);
      }
    }
    // else {
    //   try {
    //     const responseObject: ResponseObject | undefined =
    //       await apiService.get<ResponseObject>(
    //         apiService.claimServicesWithoutLogin,
    //         undefined,
    //         xHubId
    //       );
    //     setClaimData(responseObject?.object);
    //   } catch (error) {
    //     console.log("Error:", error);
    //   }
    // }
  }, [apiService, token, xHubId]);

  useEffect(() => {
    getClaimServices();
    setUpdateClaimService(false);
  }, [updateClaimService, getClaimServices]);

  return (
    <Box className="claim-service-shell">
      <Grid item container xs={12} sm={12} md={12} lg={12} margin="auto">
        <Box
          sx={{
            textAlign: "center",
            flexDirection: "column",
            alignItems: "center",
            width: "var(--salontym-content-width)",
            margin: "0 auto var(--salontym-section-gap)",
            padding: { xs: "1rem", sm: "1.6rem" },
            borderRadius: "32px",
            color: "#102117",
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(223,246,232,0.86) 52%, rgba(255,247,235,0.92) 100%)",
            border: "1px solid rgba(18,53,36,0.08)",
            boxShadow: "0 26px 70px rgba(18,53,36,0.12)",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              right: "-4rem",
              top: "-4rem",
              width: "12rem",
              height: "12rem",
              borderRadius: "999px",
              background:
                "radial-gradient(circle, rgba(255,255,255,0.72) 0%, rgba(255,255,255,0) 72%)",
            }}
          />
          <Box sx={{ width: "100%", textAlign: "left", position: "relative", zIndex: 1 }}>
            <Box className="section-eyebrow" sx={{ marginBottom: "0.85rem" }}>
              Limited-time welcome offer
            </Box>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                fontSize: { xs: "1.9rem", sm: "2.3rem" },
                color: "#102117",
              }}
              className={claimData?.about ? "claim-service-heading" : ""}
            >
              {claimData?.about}
            </Typography>
            <Typography
              sx={{
                color: "#5e6d63",
                marginTop: "0.7rem",
                maxWidth: "42rem",
                lineHeight: 1.7,
              }}
            >
              Unlock complimentary services and add one to your cart before the
              timer runs out. A calmer way to try SalonTym for the first time.
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              overflowX: "scroll",
              marginTop: "0.75rem",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              scrollbarWidth: "none", // Hide scrollbar for Firefox
              msOverflowStyle: "none", // Hide scrollbar for IE/Edge
            }}
          >
            {claimData &&
              claimData?.servicesList?.map((item: any, index: number) => (
                <Box
                  className="claim-service-card"
                  key={index}
                  sx={{
                    minWidth: { xs: "13.5rem", sm: "16rem" },
                    minHeight: { xs: "16rem", sm: "19rem" },
                    width: { xs: "13.5rem", sm: "16rem" },
                    height: { xs: "16rem", sm: "19rem" },
                    borderRadius: "1.4rem",
                    overflow: "hidden",
                    position: "relative",
                    margin: {
                      xs: "0.65rem 0.65rem 0.65rem 0px",
                      sm: "1rem 1rem 1rem 0px",
                    },
                    boxShadow: "0 22px 48px rgba(18,53,36,0.16)",
                    border: "1px solid rgba(255,255,255,0.24)",
                    background: "rgba(255,255,255,0.3)",
                  }}
                >
                  <Image
                    src={item?.coverImage?.secureHttpPath}
                    width={500}
                    height={500}
                    style={{
                      margin: "auto",
                      objectFit: "cover",
                      width: isSmallScreen ? "13.5rem" : "16rem",
                      height: isSmallScreen ? "16rem" : "19rem",
                      borderRadius: "1.4rem",
                    }}
                    alt="category"
                    // priority
                    decoding="async"
                    data-nimg="1"
                  />
                  <Box
                    style={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      background:
                        "linear-gradient(to top, rgba(10, 22, 15, 0.92) 18%, rgba(10,22,15,0.35) 62%, rgba(10,22,15,0.05) 100%)",
                    }}
                  >
                    <Box
                      sx={{
                        textAlign: "left",
                        padding: "1rem",
                        bottom: 0,
                        position: "absolute",
                        width: "-webkit-fill-available",
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#fff",
                          marginBottom: "0.2rem",
                          fontWeight: 700,
                          fontSize: { xs: "1rem", sm: "1.08rem" },
                          textShadow:
                            "0 1px 2px rgba(0,0,0,0.85), 0 2px 12px rgba(0,0,0,0.55)",
                        }}
                      >
                        {item?.name}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          color: "rgba(255,255,255,0.92)",
                          display: "block",
                          minHeight: "2rem",
                          textShadow:
                            "0 1px 2px rgba(0,0,0,0.75), 0 2px 10px rgba(0,0,0,0.45)",
                        }}
                      >
                        {item?.subHeading}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#fff",
                          marginTop: "0.7rem",
                          fontWeight: 800,
                          display: "flex",
                          alignItems: "center",
                          gap: "0.45rem",
                          flexWrap: "wrap",
                          textShadow:
                            "0 1px 2px rgba(0,0,0,0.85), 0 2px 12px rgba(0,0,0,0.55)",
                        }}
                      >
                        <span className="claim-price-pill">FREE</span>
                        <span
                          style={{
                            textDecoration: "line-through",
                            color: "#b9b4b4",
                          }}
                        >
                          {currencyCode}
                          {item?.mrp}/-
                        </span>
                      </Typography>
                      <Box
                        sx={{
                          width: "100%",
                          textAlign: "left",
                          marginTop: "0.85rem",
                        }}
                      >
                        {/* {item?.expireIn == null || undefined || 0 ? ( */}
                        {item?.claimExpire === true ? (
                          <button
                            // className="animated-button"
                            // onClick={() => handleTimer(index)}
                            style={{
                              color: "#b42318",
                              background: "rgba(255,255,255,0.92)",
                              borderRadius: "999px",
                              border: "none",
                              padding: "0.65rem 0.95rem",
                              fontSize: "13px",
                              fontFamily: "Roboto,Helvetica,Arial,sans-serif",
                              marginTop: "5px",
                              fontWeight: 700,
                            }}
                          >
                            Expired
                          </button>
                        ) : item?.expireIn > 0 ? (
                          <button
                            className={
                              showRemoveCart?.find(
                                (cartItem: any) =>
                                  cartItem.id === item.id &&
                                  cartItem.inCart == false
                              )
                                ? "animated-button-add-cart"
                                : ""
                            }
                            onClick={() => handleAddToCart(item)}
                            style={{
                              color: "white",
                              background:
                                showRemoveCart?.find(
                                  (cartItem: any) =>
                                    cartItem.id === item.id &&
                                    cartItem.inCart == false
                                )
                                  ? "linear-gradient(135deg, #123524 0%, #1f7a4d 100%)"
                                  : "rgba(255,255,255,0.92)",
                              borderRadius: "999px",
                              border: "none",
                              padding: "0.7rem 1rem",
                              fontSize: "12px",
                              fontFamily: "Roboto,Helvetica,Arial,sans-serif",
                              cursor: "pointer",
                              marginTop: "5px",
                              fontWeight: 700,
                              boxShadow: "0 14px 28px rgba(18,53,36,0.2)",
                            }}
                          >
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            {showRemoveCart?.find(
                              (cartItem: any) =>
                                cartItem.id === item.id &&
                                cartItem.inCart == false
                            )
                              ? "Add to Cart"
                              : "Remove"}
                          </button>
                        ) : (
                          <button
                            className="animated-button"
                            onClick={() => handleTimer(item, index)}
                            style={{
                              color: "#00fd00",
                              background: "rgba(7, 15, 10, 0.95)",
                              borderRadius: "999px",
                              border: "none",
                              padding: "0.7rem 1rem",
                              fontSize: "14px",
                              fontFamily: "Roboto,Helvetica,Arial,sans-serif",
                              cursor: "pointer",
                              marginTop: "5px",
                              fontWeight: 700,
                              boxShadow: "0 16px 30px rgba(0,0,0,0.24)",
                            }}
                          >
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            Claim Now
                          </button>
                        )}

                        <Box sx={{ marginTop: "0.75rem" }}>
                          {item?.expireIn == null || undefined || 0 ? (
                            ""
                          ) : (
                            <CountDown
                              offerTimerValid={false}
                              expireIn={item?.expireIn}
                            />
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              ))}
          </Box>
        </Box>
      </Grid>
      <Login
        showLoginBox={showLoginBox}
        handleLoginClose={() => setShowLoginBox(false)}
        handleUserLoggedIn={handleUserLoggedIn}
      />
      <ClaimServiceAlert
        openInfo={showClaimMessage}
        handleClose={() => setShowClaimMessage(false)}
      />
    </Box>
  );
};
